import { NavigationManager } from './navigation/navigationManager';
import { UtilityManager } from './utils/utilityManager';
import { CarouselsManager } from './carousels/carouselsManager';
import { CharacterCounterManager } from './character-counter/characterCounterManager';
import { SearchManager } from './search/searchManager';
import { Logger } from './utils/logger';
import { ConfigManager } from './config/configManager';
import { windowScope } from './window/windowScope';

export class App {
    private static instance: App;
    public navigation: NavigationManager;
    public utility: UtilityManager;
    public carousels: CarouselsManager;
    public characterCounters: CharacterCounterManager;
    public search: SearchManager;
    public configManager: ConfigManager;
    public logger: Logger;

    private constructor() {
        this.navigation = new NavigationManager();
        this.utility = new UtilityManager();
        this.carousels = new CarouselsManager();
        this.characterCounters = new CharacterCounterManager();
        this.logger = new Logger();
        this.search = new SearchManager();
        this.configManager = new ConfigManager();
    }

    public static getInstance(): App {
        if (!App.instance) {
            App.instance = new App();
        }

        return App.instance;
    }

    public initialize(): void {
        this.logger.info('Initializing GDS application...');

        // Initialize navigation with personalization manager check
        if ((window as any).personalizationManager) {
            (window as any).personalizationManager.addPersonalizedContentLoaded(() => {
                this.navigation.initialize();
            });
        } else {
            this.navigation.initialize();
        }

        this.utility.initialize();
        this.carousels.initialize();
        this.search.initialize();
        this.configManager.initialize();
        this.characterCounters.initialize();

        // Setup resize handler
        this.setupResizeHandler();

        // Setup scroll handler
        this.setupScrollHandler();

        // Setup load handler - KEEP THIS LAST within initialize()
        this.setupLoadHandler();
    }

    private setupResizeHandler(): void {
        let resizeTimeout: any;

        window.addEventListener('resize', () => {
            // Fire event when user has stopped resizing
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.navigation.onResize();
                this.utility.onResize();
            }, 150);
        });
    }

    private setupLoadHandler(): void {
        const docBody = document.body;
        document.addEventListener('DOMContentLoaded', () => {
            docBody.classList.add('dom-ready');
        });
        window.addEventListener('load', () => {
            docBody.classList.add('page-loaded');
            this.navigation.checkMegaMenuEdge();
        });
        const event = new CustomEvent('sbxJsLoaded', {
            detail: { message: 'JavaScript has finished loading' }
        });
        document.dispatchEvent(event);
    }

    // Add scroll handler method
    private setupScrollHandler(): void {
        window.addEventListener('scroll', () => {
            this.utility.onScroll();
        });
    }
}

(function(){
    const app = App.getInstance();

    windowScope.Bod = document.querySelector('body');
    windowScope.app = app;


    app.initialize();
})();